import { mapState, mapGetters } from "vuex";

export const ProductCardMixin = {
  data() {
    return {
      to_cart_loading: false,
      fallback: require("@/static/fallback_drug_picture.png"),
    };
  },
  props: {
    product: Object,
  },
  computed: {
    ...mapGetters("shoppingcart", ["cartData"]),
    ...mapState({
      authenticated: state => state.auth.authenticated,
    }),
    price: function() {
      return (this.product.best_price || {}).all_included_price;
    },
    currency: function() {
      return (this.product.best_price || {}).all_included_price_currency;
    },
    pharmacyName: function() {
      return (this.product.best_price || {}).manager_public_name;
    },
    productRoute: function() {
      return {
        name: "product_sheet",
        params: {
          drugUuid: this.product.uuid,
        },
      };
    },
    discount: function() {
      return (
        (this.product.best_price &&
          this.product.best_price.discounts &&
          this.product.best_price.discounts.length > 0 &&
          this.product.best_price.discounts[0]) ||
        undefined
      );
    },
    discountPercent: function() {
      return Number(this.discount.percent_value);
    },
    discountPackQuantity: function() {
      return this.discount.pack_quantity;
    },
    // Tenemos un problema en el backend, cuando calcula el precio anterior lo
    // hace sin incluir las tatas. Esto no es del todo incorrecto, pero el
    // cliente quiere ver los precios anteriores con iva.
    // Mientras pensamos algún modo de traérnos del backend el precio anterior
    // tanto sin IVA como con IVA aplicado, realizamos el cálculo aquí.
    priceBefore: function() {
      if (!this.product.best_price) {
        return undefined;
      }
      if (!this.product.best_price.price_before) {
        return undefined;
      }

      if (!this.product.best_price.taxes) {
        return this.product.best_price.price_before;
      }

      if (!this.product.best_price.taxes.length) {
        return this.product.best_price.price_before;
      }

      let price_before = Number(this.product.best_price.price_before);
      let base = Number(this.product.best_price.base);
      if (price_before == base) {
        let before = Number(0);
        this.product.best_price.taxes.forEach(tax => {
          let percent = tax.percent_value / 100 + 1;
          before += Number(base * percent);
        });
        if (isNaN(before)) {
          return price_before;
        }
        return before;
      }

      return this.product.best_price.price_before;
    },
  },
  methods: {
    buyProduct(quantity, buy = false) {
      if (this.product.can_buy_only_if_has_logged && !this.authenticated) {
        this.mnotify_error({
          text: this.$t("product_card_mixin.error.can_buy_only_if_has_logged"),
        });
      } else {
        this.to_cart_loading = true;
        this.$store
          .dispatch("shoppingcart/ADD_PRODUCT", {
            price: this.product.best_price,
            quantity: quantity || 1,
            product: this.product,
          })
          .then(
            () => {
              this.to_cart_loading = false;
              if (buy) {
                // ojo, si no se comprueba que esté authenticado
                // podría estar NO authenticado pero tener datos
                // en this.cartData de una sesión previa
                if (this.cartData && this.cartData.checkout) {
                  this.$router.push({
                    name: "cart_confirm",
                    params: { checkout_uuid: this.cartData.checkout },
                  });
                } else {
                  // El View cart review es capaz de obtener
                  // el carrito, por lo que es capaz de moverse
                  // diréctamente al checkout. Con el subaction confirm
                  // le decimos que lo haga
                  this.$router.push({
                    name: "cart_review",
                    params: { subaction: "confirm" },
                  });
                }
              }
            },
            err => {
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("product_card_mixin.error.buy_product"),
              });
              this.to_cart_loading = false;
            }
          );
      }
    },
    imageLoadError(evt) {
      evt.srcElement.src = require("@/static/fallback_drug_picture.png");
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        product_card_mixin: {
          error: {
            buy_product: "Cannot add product to the shopping cart",
            can_buy_only_if_has_logged:
              "You can only buy this product if you are logged in",
          },
        },
      },
    },
  },
};
